module.exports = __webpack_public_path__ + "static/img/szafa_12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/szafa_12.jpg
// module id = NDyc
// module chunks = 0